module.exports = __webpack_public_path__ + "img/empty-page.25d557f0.svg";